export const serviceMenuItems = [
	{
		title: 'Music therapy',
		path: '/services/music-therapy',
		cName: 'dropdown-link',
	},

	{
		title: 'Piano teaching',
		path: '/services/piano-teaching',
		cName: 'dropdown-link',
	},
];

export const performanceMenuItems = [
	{
		title: 'Interactive Music Performances',
		path: '/performances/interactive-music',
		cName: 'dropdown-link',
	},
	{
		title: 'Meet the team',
		path: '/performances/meet-the-team',
		cName: 'dropdown-link',
	},
];
